import { __extends } from "tslib";
import { Texture } from "./texture";
import "../../Engines/Extensions/engine.rawTexture";
/**
 * Class used to store 2D array textures containing user data
 */
var RawTexture2DArray = /** @class */ (function (_super) {
    __extends(RawTexture2DArray, _super);
    /**
     * Create a new RawTexture2DArray
     * @param data defines the data of the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param depth defines the number of layers of the texture
     * @param format defines the texture format to use
     * @param scene defines the hosting scene
     * @param generateMipMaps defines a boolean indicating if mip levels should be generated (true by default)
     * @param invertY defines if texture must be stored with Y axis inverted
     * @param samplingMode defines the sampling mode to use (Texture.TRILINEAR_SAMPLINGMODE by default)
     * @param textureType defines the texture Type (Engine.TEXTURETYPE_UNSIGNED_INT, Engine.TEXTURETYPE_FLOAT...)
     */
    function RawTexture2DArray(data, width, height, depth, 
    /** Gets or sets the texture format to use */
    format, scene, generateMipMaps, invertY, samplingMode, textureType) {
        if (generateMipMaps === void 0) { generateMipMaps = true; }
        if (invertY === void 0) { invertY = false; }
        if (samplingMode === void 0) { samplingMode = Texture.TRILINEAR_SAMPLINGMODE; }
        if (textureType === void 0) { textureType = 0; }
        var _this = _super.call(this, null, scene, !generateMipMaps, invertY) || this;
        _this.format = format;
        _this._texture = scene.getEngine().createRawTexture2DArray(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, null, textureType);
        _this.is2DArray = true;
        return _this;
    }
    /**
     * Update the texture with new data
     * @param data defines the data to store in the texture
     */
    RawTexture2DArray.prototype.update = function (data) {
        if (!this._texture) {
            return;
        }
        this._getEngine().updateRawTexture2DArray(this._texture, data, this._texture.format, this._texture.invertY, null, this._texture.type);
    };
    return RawTexture2DArray;
}(Texture));
export { RawTexture2DArray };
//# sourceMappingURL=rawTexture2DArray.js.map